<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="fmt02">
<h2 class="chaptertitle">A WORD ON THE ORTHOGRAPHY AND PRONUNCIATION</h2>
<p class="body-text">The Malagasy language has dialectical variation throughout the island. In the book, Malagasy words reflect either the standard Merina spelling (“official Malagasy”) or the Betsimisaraka pronunciation, depending on the context.</p>
<p class="indent">In the Merina dialect, the letter <i>o</i> is pronounced like the English <i>oo</i> (as in “zoom”). In the northern Betsimisaraka dialect, <i>o</i> is frequently pronounced long (as in the English “oh”). When I cite a Betsimisaraka speaker, I use the diacritical <i>ô.</i> Thus the Merina word <i>vola</i> (money) becomes <i>vôla</i> in Betsimisaraka, for example.</p>
<p class="indent">In Merina, the letter <i>n</i> is pronounced as in English, but the Betsimisaraka dialect frequently employs the velar nasal (the <i>ng</i> sound in “sing”) where Merina does not. The velar nasal is conventionally written as <i>ñ</i> in the ethnographic literature of Madagascar. Thus <i>razana</i> (ancestor) in Merina becomes <i>razaña</i> in Betsimisaraka.</p>
<p class="indent">When citing the work of other Madagascar scholars, I copy the spelling they use for Malagasy vocabulary.</p>
</a></div><a id="fmt02">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter01.vue?65fef687